import { render, staticRenderFns } from "./maillist.vue?vue&type=template&id=32936672&"
import script from "./maillist.vue?vue&type=script&lang=js&"
export * from "./maillist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports